import React from 'react'
import reduce from 'lodash/reduce'

const interfaceNamesTransitionObject = {
  columnDefs: 'iColumnDefs',
  rowData: 'iRowData',

  getContextMenuItems: 'iGetContextMenuItems',
  sortConfig: 'iSortConfig',
  iconsConfig: 'iIconsConfig',

  gridIdentity: 'iGridIdentity',

  syncGridState: 'iSyncGridState',
  disabled: 'iDisabled',
  selectFirstRow: 'iSelectFirstRow',
  selectLastRow: 'iSelectLastRow',
  enableColumnsResize: 'iEnableColumnsResize',
  enableColumnsOrder: 'iEnableColumnsOrder',
  enableColumnsHide: 'iEnableColumnsHide',

  deltaRowDataMode: 'iDeltaRowDataMode',
  getRowNodeId: 'iGetRowNodeId',

  enableRowSelection: 'iEnableRowSelection',
  onRowSelected: 'iOnRowSelected',
  onRowDoubleClicked: 'iOnRowDoubleClicked',
  onGridReady: 'iOnGridReady',

  onCellClicked: 'iOnCellClicked',

  enableSorting: 'iEnableSorting',
  columnConfigs: 'iColumnConfigs',

  getRowStyle: 'iGetRowStyle',
  getRowClass: 'iGetRowClass',

  loading: 'iLoading',

  statusBarConfig: 'iStatusBarConfig',
  showCellFocus: 'iShowCellFocus',
}

const renameProps = (props) =>
  reduce(
    props,
    (acc, value, key) => {
      const transitionKey = interfaceNamesTransitionObject[key] || key
      acc[transitionKey] = value
      return acc
    },
    {},
  )

const withLKGridInterface = (WrappedComponent) => (props) => <WrappedComponent {...renameProps(props)} />

export default withLKGridInterface
